import { Box, TextField } from '@mui/material'
import { useSelector, useDispatch } from 'react-redux'
import { numberInputStyle, textAreaStyle } from '../../constants/styleConstants'
import { AppDispatch } from '../../store'
import questionsSelector from '../../store/questions/questionsSelector'
import {
  updateNewCaseAnswerText,
  updateVictimAnswerText,
} from '../../store/questions/questionsSlice'
import { findItemByUuid } from '../../store/reports/reportsSlice'
import { IQuestionV2, MainObject } from '../../store/reports/types'
import LabelErrorTAG from '../LabelErrorTAG'

interface INumberQuestion {
  question: IQuestionV2
  victimQuestionId?: number | null
}
const NumberQuestion: React.FC<INumberQuestion> = ({ question, victimQuestionId = null }) => {
  const getAnswer = () => {
    if (victimQuestionId) {
      return useSelector(questionsSelector.getVictimAnswer(victimQuestionId, question?.uuid))
    }
    return useSelector(questionsSelector.answerToNewCaseQuestion(question?.uuid))
  }
  const answer = getAnswer()
  const dispatch = useDispatch<AppDispatch>()

  const onChangeHandler = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (victimQuestionId) {
      dispatch(
        updateVictimAnswerText({
          victimId: victimQuestionId,
          answerUUID: answer?.uuid,
          answerText: e.target.value as unknown as number,
        }),
      )
      return
    }
    dispatch(
      updateNewCaseAnswerText({
        answerUUID: answer?.uuid,
        answerText: e.target.value as unknown as number,
      }),
    )
  }

  return (
    <Box sx={{ width: '100%' }}>
      <LabelErrorTAG label={question?.variant?.label} />
      <TextField
        onChange={onChangeHandler}
        value={answer?.answer.text}
        style={numberInputStyle}
        type='number'
        size='small'
        InputProps={{
          inputProps: { min: 0, max: 100 },
        }}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </Box>
  )
}

export default NumberQuestion
